import DialogModal from 'src/components/ui/dialogModal';
import Dropdown from 'src/components/ui/dropdownMenu/dropdownMenu';
import Form from './Form/Form';
import { HttpStatusCode } from 'src/utils/enums/http-method.enum';
import { IUserData } from './../Body';
import ProfileOptionsIcon from 'src/components/dealer-mgmt/profile-options-icon';
import { useLocalization } from 'src/utils/useLocalization';
import {
    DealerAssociation,
    DealerPermission,
} from 'src/services/models/dealer-management.service';
import {
    DealerManagementService,
    ISendPasswordResetLinkPayload,
} from 'src/services/dealer-management.service';
import Notification, {
    NotificationType,
} from 'src/components/ui/notification/Notification';
import React, { useState } from 'react';

import './styles.scss';

//User status
const MenuItem = ({
    active,
    status,
    isUserLocked,
    showOnlyDeleteOption,
    passwordResetdHanlder,
    unlockHanlder,
    resetMFAHandler,
    activateHandler,
    deactivateHandler,
    deleteHandler,
}: {
    active: boolean;
    status: number;
    isUserLocked: boolean;
    showOnlyDeleteOption?: boolean;
    passwordResetdHanlder: Function;
    unlockHanlder: Function;
    resetMFAHandler: Function;
    activateHandler: Function;
    deactivateHandler: Function;
    deleteHandler: Function;
}) => {
    const { dealerMgmt, editUser } = useLocalization();
    const DEACTIVATED_STATUS = 1;
    const ACTIVATED_STATUS = 0;
    return (
        <>
            {!showOnlyDeleteOption && (
                <>
                    <li
                        className={`menu-items ${!active ? 'disabled' : null}`}
                        onClick={() =>
                            active ? passwordResetdHanlder() : null
                        }
                    >
                        <span>{editUser.BUTTON_RESET_PWD_LABEL}</span>
                    </li>
                    <li
                        className='menu-items'
                        onClick={() => {
                            resetMFAHandler();
                        }}
                    >
                        <span>
                            {dealerMgmt.DEALER_MGMT_TABLE_MENU_DELETEMFA}
                        </span>
                    </li>
                    {status === DEACTIVATED_STATUS && (
                        <li
                            className='menu-items'
                            onClick={() => {
                                activateHandler();
                            }}
                        >
                            <span>
                                {dealerMgmt.DEALER_MGMT_TABLE_MENU_ACTIVATE}
                            </span>
                        </li>
                    )}
                    {status === ACTIVATED_STATUS && (
                        <li
                            className='menu-items'
                            onClick={() => {
                                deactivateHandler();
                            }}
                        >
                            <span>
                                {dealerMgmt.DEALER_MGMT_TABLE_MENU_DEACTIVATE}
                            </span>
                        </li>
                    )}
                    <li
                        className={`menu-items ${
                            !isUserLocked ? 'disabled' : null
                        }`}
                        onClick={() => {
                            isUserLocked ? unlockHanlder() : null;
                        }}
                    >
                        <span>{editUser.BUTTON_UNLOCK_LABEL}</span>
                    </li>
                </>
            )}
            <li
                className={`${showOnlyDeleteOption ? 'mb-0 ' : ''}menu-items`}
                onClick={() => {
                    deleteHandler();
                }}
            >
                <span style={{ color: 'rgb(228, 0, 44)' }}>
                    {dealerMgmt.DEALER_MGMT_TABLE_MENU_DELETE}
                </span>
            </li>
        </>
    );
};

interface IProfileProps {
    userData: IUserData;
    fullName: string;
    dealerPermissions: Array<DealerPermission>;
    dealerAssociations: Array<DealerAssociation>;
    getDealerUserData: Function;
    isUserActive: boolean;
    deleteSuccessHandler: Function;
    showOnlyDeleteOption?: boolean;
    isDSMSearch?: boolean;
}

const Profile: React.FC<IProfileProps> = ({
    userData,
    fullName,
    dealerPermissions,
    dealerAssociations,
    getDealerUserData,
    isUserActive,
    deleteSuccessHandler,
    showOnlyDeleteOption,
    isDSMSearch = false,
}) => {
    const { editUser, addNewUser, dealerMgmt } = useLocalization();
    const [isError, setIsError] = useState<boolean>(false);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [openDrop, setOpenDrop] = useState<boolean>(false);
    const [successNotification, setSuccessNotification] = useState<string>(
        editUser.NOTIFICATION_SUCCESS_REQUEST,
    );
    const [errorNotification, setErrorNotification] = useState<string>(
        editUser.NOTIFICATION_ERROR_REQUEST,
    );
    const [, setIsLoading] = useState<boolean>(false);

    const disabledClass = !isUserActive ? ' disabled' : '';

    async function onPasswordResetdHanlder() {
        setIsLoading(true);
        setIsSuccess(false);
        setIsError(false);
        const service = new DealerManagementService();
        const request = {
            userId: userData.userId,
        };
        try {
            await service.sendPasswordResetLink(
                request as ISendPasswordResetLinkPayload,
            );
            setIsLoading(false);
            setSuccessNotification(
                editUser.NOTIFICATION_SUCCESS_PASSWORDRESETLINK,
            );
            setIsSuccess(true);
        } catch (error: any) {
            const message =
                error.response.status == HttpStatusCode.LOCKED
                    ? editUser.NOTIFICATION_ERROR_PASSWORDRESETLINK_LOCKED
                    : editUser.NOTIFICATION_ERROR_REQUEST;
            setIsLoading(false);
            setErrorNotification(message);
            setIsError(true);
        }
    }

    async function onUnlockHanlder() {
        setIsLoading(true);
        setIsSuccess(false);
        setIsError(false);
        const service = new DealerManagementService();
        try {
            await service.unlockUser(userData.email, userData.userId);
            await getDealerUserData(true);
            setIsLoading(false);
            setSuccessNotification(editUser.NOTIFICATION_SUCCESS_UNLOCK);
            setIsSuccess(true);
        } catch (error: any) {
            setIsLoading(false);
            setErrorNotification(editUser.NOTIFICATION_ERROR_REQUEST);
            setIsError(true);
        }
    }

    async function onResetMFAHanlder() {
        setIsLoading(true);
        setIsSuccess(false);
        setIsError(false);
        const service = new DealerManagementService();
        try {
            await service.resetMfa(userData.email);
            await getDealerUserData(true);
            setIsLoading(false);
            setSuccessNotification(
                dealerMgmt.DEALER_MGMT_TABLE_USER_MESSAGES_SUCCESSMFA_DELETED,
            );
            setIsSuccess(true);
        } catch (error: any) {
            setIsLoading(false);
            setErrorNotification(editUser.NOTIFICATION_ERROR_REQUEST);
            setIsError(true);
        }
    }

    const onActivateDeactivateHanlder = async (status: number) => {
        setIsLoading(true);
        setIsSuccess(false);
        setIsError(false);
        const service = new DealerManagementService();
        try {
            await service.updateUserStatus(userData.userId, status);
            await getDealerUserData(true);
            setIsLoading(false);
            setIsSuccess(true);
        } catch (error) {
            setIsLoading(false);
            setErrorNotification(editUser.NOTIFICATION_ERROR_REQUEST);
            setIsError(true);
        }
    };
    const onDeleteUserHanlder = async () => {
        setIsLoading(true);
        setIsSuccess(false);
        setIsError(false);
        const service = new DealerManagementService();
        try {
            await service.deleteUser(userData.userId, userData.email);
            deleteSuccessHandler();
        } catch (error) {
            setIsLoading(false);
            setErrorNotification(editUser.NOTIFICATION_ERROR_REQUEST);
            setIsError(true);
        }
    };

    enum UserModalStatus {
        DELETE = 'DELETE',
        ACTIVATE = 'ACTIVATE',
        DEACTIVATE = 'DEACTIVATE',
        DELETEMFA = 'DELETEMFA',
        UNLOCK = 'UNLOCK',
        RESET = 'RESET',
    }

    const [modalOpen, setModalOpen] = useState<string>('');
    const [modalIsLoading, setModalIsLoading] = useState<boolean>(false);

    const handleModalCancel = () => {
        setModalOpen('');
    };

    const DEACTIVATED_STATUS = 1;
    const ACTIVATED_STATUS = 0;

    const deleteMFAConfirm = () => {
        setModalIsLoading(true);
        onResetMFAHanlder()
            .then(() => {
                setModalOpen('');
                setModalIsLoading(false);
            })
            .catch(() => {
                setModalIsLoading(false);
            })
            .finally(() => {
                setModalIsLoading(false);
                handleModalCancel();
            });
    };

    const resetConfirm = () => {
        setModalIsLoading(true);
        onPasswordResetdHanlder()
            .then(() => {
                setModalOpen('');
                setModalIsLoading(false);
            })
            .catch(() => {
                setModalIsLoading(false);
            })
            .finally(() => {
                setModalIsLoading(false);
                handleModalCancel();
            });
    };

    const unlockConfirm = () => {
        setModalIsLoading(true);
        onUnlockHanlder()
            .then(() => {
                setModalOpen('');
                setModalIsLoading(false);
            })
            .catch(() => {
                setModalIsLoading(false);
            })
            .finally(() => {
                setModalIsLoading(false);
                handleModalCancel();
            });
    };

    const deleteConfirm = () => {
        setModalIsLoading(true);
        onDeleteUserHanlder()
            .then(() => {
                setModalOpen('');
                setModalIsLoading(false);
            })
            .catch(() => {
                setModalIsLoading(false);
            })
            .finally(() => {
                setModalIsLoading(false);
                handleModalCancel();
            });
    };

    const activateConfirm = () => {
        setModalIsLoading(true);
        onActivateDeactivateHanlder(ACTIVATED_STATUS)
            .then(() => {
                setModalOpen('');
                setModalIsLoading(false);
                setSuccessNotification(
                    editUser.NOTIFICATION_SUCCESS_ACTIVATION,
                );
            })
            .catch(() => {
                setModalIsLoading(false);
            })
            .finally(() => {
                setModalIsLoading(false);
                handleModalCancel();
            });
    };

    const deactivateConfirm = () => {
        setModalIsLoading(true);
        onActivateDeactivateHanlder(DEACTIVATED_STATUS)
            .then(() => {
                setModalOpen('');
                setModalIsLoading(false);
                setSuccessNotification(
                    editUser.NOTIFICATION_SUCCESS_DEACTIVATION,
                );
            })
            .catch(() => {
                setModalIsLoading(false);
            })
            .finally(() => {
                setModalIsLoading(false);
                handleModalCancel();
            });
    };

    const handleModalOpen = (value: UserModalStatus) => {
        setModalOpen(value);
    };

    const getConfirmBtnLabel = () => {
        let label = '';
        switch (modalOpen) {
            case UserModalStatus.DELETE: {
                label = dealerMgmt.DEALER_MGMT_DELETE_MODAL_CONFIRM_BUTTON;
                break;
            }
            case UserModalStatus.ACTIVATE: {
                label = dealerMgmt.DEALER_MGMT_ACTIVATE_MODAL_CONFIRM_BUTTON;
                break;
            }
            case UserModalStatus.DEACTIVATE: {
                label = dealerMgmt.DEALER_MGMT_DEACTIVATE_MODAL_CONFIRM_BUTTON;
                break;
            }
            case UserModalStatus.DELETEMFA: {
                label = dealerMgmt.DEALER_MGMT_DELETEMFA_MODAL_CONFIRM_BUTTON;
                break;
            }
            case UserModalStatus.UNLOCK: {
                label = dealerMgmt.DEALER_MGMT_UNLOCK_MODAL_CONFIRM_BUTTON;
                break;
            }
            case UserModalStatus.RESET: {
                label = dealerMgmt.DEALER_MGMT_RESETPASS_MODAL_CONFIRM_BUTTON;
                break;
            }
            default: {
                break;
            }
        }
        return label;
    };

    const getBodyContent = () => {
        let label = '';
        switch (modalOpen) {
            case UserModalStatus.DELETE: {
                label = dealerMgmt.DEALER_MGMT_DELETE_MODAL_DESCRIPTION;
                break;
            }
            case UserModalStatus.ACTIVATE: {
                label = dealerMgmt.DEALER_MGMT_ACTIVATE_MODAL_DESCRIPTION;
                break;
            }
            case UserModalStatus.DEACTIVATE: {
                label = dealerMgmt.DEALER_MGMT_DEACTIVATE_MODAL_DESCRIPTION;
                break;
            }
            case UserModalStatus.DELETEMFA: {
                label = dealerMgmt.DEALER_MGMT_DELETEMFA_MODAL_DESCRIPTION;
                break;
            }
            case UserModalStatus.UNLOCK: {
                label = dealerMgmt.DEALER_MGMT_UNLOCK_MODAL_DESCRIPTION;
                break;
            }
            case UserModalStatus.RESET: {
                label = dealerMgmt.DEALER_MGMT_RESETPASS_MODAL_DESCRIPTION;
                break;
            }
            default: {
                break;
            }
        }
        return label;
    };

    const getTitle = () => {
        let label = '';
        switch (modalOpen) {
            case UserModalStatus.DELETE: {
                label = `${dealerMgmt.DEALER_MGMT_DELETE_MODAL_TITLE} ${fullName}`;
                break;
            }
            case UserModalStatus.ACTIVATE: {
                label = dealerMgmt.DEALER_MGMT_TABLE_MENU_ACTIVATE;
                break;
            }
            case UserModalStatus.DEACTIVATE: {
                label = dealerMgmt.DEALER_MGMT_DEACTIVATE_MODAL_TITLE;
                break;
            }
            case UserModalStatus.DELETEMFA: {
                label = dealerMgmt.DEALER_MGMT_DELETEMFA_MODAL_TITLE;
                break;
            }
            case UserModalStatus.UNLOCK: {
                label = dealerMgmt.DEALER_MGMT_UNLOCK_MODAL_TITLE;
                break;
            }
            case UserModalStatus.RESET: {
                label = dealerMgmt.DEALER_MGMT_RESETPASS_MODAL_TITLE;
                break;
            }
            default: {
                break;
            }
        }
        return label;
    };

    return (
        <div className={'edit-user-container__profile'}>
            {isError && (
                <Notification
                    content={errorNotification}
                    type={NotificationType.ERROR}
                    visibility={isError}
                    setVisibility={setIsError}
                />
            )}
            {isSuccess && (
                <Notification
                    content={successNotification}
                    type={NotificationType.SUCCESS}
                    visibility={isSuccess}
                    setVisibility={setIsSuccess}
                />
            )}
            {userData.isUserLocked && (
                <Notification
                    content={editUser.EDIT_USER_NOTIFICATION_WARNING_LOCKED}
                    type={NotificationType.WARNING}
                    visibility={true}
                    setVisibility={() => {
                        return;
                    }}
                />
            )}
            <div
                className={
                    'edit-user-container__profile-header' + disabledClass
                }
            >
                <div>{fullName}</div>
                <div
                    className={`button-container ${
                        userData.isUserLocked ? '' : 'container-only-child'
                    }`}
                >
                    <span
                        className='options-icon'
                        onClick={() => {
                            setOpenDrop(true);
                        }}
                    >
                        <ProfileOptionsIcon />
                    </span>
                    <Dropdown
                        dropdown={openDrop}
                        showSelected={false}
                        showSelectedIcon={false}
                        handlerChange={(value: boolean) => {
                            setOpenDrop(value);
                        }}
                    >
                        <MenuItem
                            active={isUserActive}
                            status={userData.userStatus}
                            isUserLocked={userData.isUserLocked}
                            showOnlyDeleteOption={showOnlyDeleteOption}
                            resetMFAHandler={() => {
                                handleModalOpen(UserModalStatus.DELETEMFA);
                            }}
                            passwordResetdHanlder={() => {
                                handleModalOpen(UserModalStatus.RESET);
                            }}
                            unlockHanlder={() => {
                                handleModalOpen(UserModalStatus.UNLOCK);
                            }}
                            activateHandler={() => {
                                handleModalOpen(UserModalStatus.ACTIVATE);
                            }}
                            deactivateHandler={() => {
                                handleModalOpen(UserModalStatus.DEACTIVATE);
                            }}
                            deleteHandler={() => {
                                handleModalOpen(UserModalStatus.DELETE);
                            }}
                        />
                    </Dropdown>
                </div>
            </div>
            <div
                className={
                    'edit-user-container__profile-allfields' + disabledClass
                }
            >
                <span>*</span>
                {addNewUser.BODY_ALLFIELDS}
            </div>
            <Form
                userData={userData}
                setIsSuccessNotification={setIsSuccess}
                setIsErrorNotification={setIsError}
                dealerPermissions={dealerPermissions}
                dealerAssociations={dealerAssociations}
                getDealerUserData={getDealerUserData}
                isUserActive={isUserActive}
                setSuccessNotificationMessage={setSuccessNotification}
                setErrorNotificationMessage={setErrorNotification}
                isDSMSearch={isDSMSearch}
            />
            <DialogModal
                titleContent={getTitle()}
                bodyContent={getBodyContent()}
                open={modalOpen !== ''}
                cancelBtnLabel={addNewUser.MODAL_LABEL_BUTTON_CANCEL}
                confirmBtnLabel={getConfirmBtnLabel()}
                onCancelHandler={handleModalCancel}
                onConfirmHandler={() => {
                    switch (modalOpen) {
                        case UserModalStatus.DELETE: {
                            deleteConfirm();
                            break;
                        }
                        case UserModalStatus.ACTIVATE: {
                            activateConfirm();
                            break;
                        }
                        case UserModalStatus.DEACTIVATE: {
                            deactivateConfirm();
                            break;
                        }
                        case UserModalStatus.DELETEMFA: {
                            deleteMFAConfirm();
                            break;
                        }
                        case UserModalStatus.UNLOCK: {
                            unlockConfirm();
                            break;
                        }
                        case UserModalStatus.RESET: {
                            resetConfirm();
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                }}
                isLoading={modalIsLoading}
                isConfirmBtnRed={modalOpen === UserModalStatus.DELETE}
            />
        </div>
    );
};

export default Profile;
